<template lang="html">

  <section class="menu-lateral" :showmenu="showMenu" :style="styles.bgmenu">

    <div class="contenedor-logo row-between" :style="styles.backgroundWhite">
      <router-link to="/"><img :src="logo"></router-link>
      <a @click="toggleMenu" class="toggle-menu">
        <span :style="styles.bgBasic"></span>
        <span :style="styles.bgBasic"></span>
        <span :style="styles.bgBasic"></span>
        <next></next>
      </a>
    </div>

    <div class="contenedor-enlaces" :style="styles.colorWhite">

      <router-link to="/" class="enlace-el -father -to-home">{{$t('inicio')}}</router-link>

      <template v-if="istutor">

        <router-link v-if="!brand.hideInMenu.validaciones.all" :to="$t('enlaces.validaciones')"
          class="enlace-el -father">{{(brand.menunames.validaciones) ?
          brand.menunames.validaciones : $t('validaciones')}}</router-link>
        <div class="childrens" v-if="!brand.hideInMenu.validaciones.all">
          <router-link v-if="!brand.hideInMenu.validaciones.pendientes" :to="$t('enlaces.validaciones')+'/pendientes'"
            class="enlace-el -children">{{$t('pendientes')}}</router-link>
          <router-link v-if="!brand.hideInMenu.validaciones.validadas" :to="$t('enlaces.validaciones')+'/validadas'"
            class="enlace-el -children">{{$t('validadas')}}</router-link>
          <router-link v-if="!brand.hideInMenu.validaciones.rechazadas" :to="$t('enlaces.validaciones')+'/rechazadas'"
            class="enlace-el -children">{{$t('rechazadas')}}</router-link>
        </div>
      </template>

      <template v-if="brand.soporteDirector">


        <router-link :to="$t('enlaces.aprobacionesdirector')" class="enlace-el -father" v-if="isdirector">{{$t('aprobacion_ofertas')}}
        </router-link>
        <div class="childrens" v-if="isdirector">
          <router-link :to="$t('enlaces.aprobacionesdirector')+'/pendientes'" class="enlace-el -children">{{$t('pendientes')}}
          </router-link>
          <router-link :to="$t('enlaces.aprobacionesdirector')+'/aprobadas'" class="enlace-el -children">{{$t('aprobadas')}}
          </router-link>
          <router-link :to="$t('enlaces.aprobacionesdirector')+'/denegadas'" class="enlace-el -children">{{$t('denegadas')}}
          </router-link>
        </div>

      </template>

      <template v-if="totales.numTutoradosOevaluacionAsignadas != 0">

        <router-link :to="$t('enlaces.tutorados')" class="enlace-el -father">{{$t('tutorados')}}</router-link>
        <div class="childrens">
          <router-link :to="$t('enlaces.tutorados')+'/en-curso'" class="enlace-el -children">{{$t('practicas_en_curso')}}
          </router-link>
          <router-link :to="$t('enlaces.tutorados')+'/en-evaluacion'" class="enlace-el -children">{{$t('pendiente_cierre')}}
          </router-link>
          <router-link :to="$t('enlaces.tutorados')+'/evaluados'" class="enlace-el -children">{{$t('cerrados')}}</router-link>
        </div>
        <router-link :to="$t('enlaces.miperfil')" class="enlace-el -father" v-if="brand.hasMiPerfil">{{$t('mi_perfil')}}
        </router-link>

        <router-link :to="$t('enlaces.encuestas')" class="enlace-el -father" v-if="brand.hasEncuestas">{{$t('encuestas')}}
        </router-link>

      </template>

      <template v-if="brand.firmaAnexos">
      
        <router-link :to="$t('enlaces.anexos')" class="enlace-el -father">{{$t('firmas_anexos')}}</router-link>
        <div class="childrens">
          <router-link :to="$t('enlaces.anexos')+'/pendiente_firma'" class="enlace-el -children">{{$t('pendiente_firma')}}
          </router-link>
          <router-link :to="$t('enlaces.anexos')+'/firmados'" class="enlace-el -children">{{$t('firmados')}}</router-link>
        </div>
      </template>

      <router-link :to="$t('enlaces.ofertasPracticasTutor')" class="enlace-el -father" v-if="ofertasTutores.length != 0">Ofertas Prácticas</router-link>

      <div class="contenedor-favoritos" v-if="favoritos.length > 0">

        <h3 class="enlace-el -father">{{$t('favoritos')}}</h3>

        <div class="contenedor-enlaces">

          <template v-for="(fav, key) in favoritos">

            <span>

              <button title="Borrar favorito" class="borrar-fav" @click="toggleFavoritos(fav)">✕</button>

              <router-link v-if="fav.type == 'aprobacion'" :to="$t('enlaces.fichaaprobacion')+'/'+fav.idPractica"
                class="enlace-el -children">
                {{fav.nombreEstudiante}}</router-link>

              <router-link v-if="fav.type == 'practica'" :to="$t('enlaces.ficha')+'/'+fav.idPractica"
                class="enlace-el -children">
                {{fav.nombreEstudiante}}</router-link>

            </span>

          </template>

        </div>

      </div>


    </div>

    </div>


    <p class="version">{{version}}</p>

    <idioma v-if="brand.languagebydefault"></idioma>

  </section>

</template>

<script lang="js">

  import { mapActions, mapGetters } from 'vuex';

  import next from '@/components/parts/icons/next';

  import idioma from '@/components/parts/idioma';

  export default {
    name: 'menu-lateral',
    computed: {
      ...mapGetters({
        showMenu: 'getShowMenu',
        logo: 'getLogoColor',
        styles: 'getStyles',
        favoritos: 'getFavoritos',
        version: 'getVersion',
        brand: 'getBrand',
        istutor: 'getIsTutor',
        isdirector: 'getIsDirector',
        totales: 'getTotales',
        ofertasTutores: 'getOfertasTutores'
      })
    },
    methods: {
      ...mapActions(['toggleMenu', 'toggleFavoritos', 'setMenu']),
      checkMenu: function () {
        var width = $(window).width();
        if (width <= 1024) {
          this.setMenu(false);
        }
      }
    },
    components: {
      'next': next,
      'idioma' : idioma
    },
    watch: {
      '$route': function () {
        this.checkMenu();
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/css/colors.scss';

  .menu-lateral {
    width: 100%;
    max-width: 240px;
    height: 100%;
    min-height: 100vh;
    max-height: 100vh;
    position: absolute;
    left: -240px;
    top: 0;
    will-change: transform;
    transition: .5s;
    transition-timing-function: ease-in-out;
    z-index: 8;



    &[showmenu=true] {
      transform: translateX(100%);
    }
  }

  .contenedor-logo {
    width: 100%;
    text-align: left;
    padding: 20px;
    position: relative;
    height: $top-height;
    margin-bottom: 10px;

    >a {
      width: 100%;
      max-width: 130px;
      display: block;
      max-height: 50px;
    }

    img {
      max-width: 130px;
      max-height: 50px;
      display: block;
    }

    .toggle-menu {
      width: 32px;
      height: 22px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      transform: translateX(65px);
      transition: .5s;
      transition-timing-function: ease-in-out;

      span {
        height: 2px;
        width: 100%;
        display: inline-block;
        background: blue;
        position: absolute;
        left: 0;
        top: 0;
        padding-right: 12px;
      }

      span:nth-child(2) {
        top: 50%;
        margin-top: -1px;
      }

      span:last-of-type {
        top: auto;
        bottom: 0;
      }

      svg {
        top: 50%;
        right: -15px;
        position: absolute;
        transform: translate(0px, -50%);
        width: 12px;
      }

    }

  }

  [showmenu=true] .contenedor-logo {
    .toggle-menu {
      transform: translateX(0px);

      svg {
        transform: translate(-50px, -50%) rotate(-180deg);
      }
    }
  }

  .contenedor-enlaces {
    width: 100%;
    text-align: left;
    overflow: scroll;
    overflow-x: hidden;
    max-height: calc(100vh - 110px)
  }

  .enlace-el {
    width: 100%;
    display: block;
    cursor: pointer;
    font-weight: 300;
    font-size: 16px;

    &.router-link-active {
      background: rgba(0, 0, 0, .3);
    }

    &.router-link-active.-to-home {
      background: rgba(0, 0, 0, 0);
    }

    &.router-link-exact-active {
      background: rgba(0, 0, 0, 1);
      font-weight: bold;
    }

    &:hover {
      background: rgba(0, 0, 0, .5);
    }

    &.-father {
      /*border-top: 1px solid rgba(255,255,255,.2);*/
      padding: 10px 20px;
    }

    &.-father:first-of-type {
      border: none;
    }

    &.-children {
      padding: 10px 0 10px 40px;
      font-size: 14px;

    }
  }

  .contenedor-favoritos {

    span {
      position: relative;
      display: block;
    }

    .-children {
      font-size: 13px;
      max-width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .borrar-fav {
      position: absolute;
      left: 10px;
      top: 50%;
      width: 20px;
      height: 20px;
      border: 1px solid white;
      border-radius: 50%;
      background: none;
      font-size: 12px;
      transform: translateY(-50%);
      opacity: 0;
      transition: .5s;
      cursor: pointer;
      outline: none;
    }

    span:hover .borrar-fav {
      opacity: 1;
    }
  }

  @media screen and (max-width: 1400px) {
    .contenedor-logo {
      padding: 10px;
      height: 75px;
    }

    .contenedor-enlaces {
      max-height: calc(100vh - 85px);
    }
  }

  @media screen and (max-width: 1024px) {
    .menu-lateral {
      &[showmenu=true] {
        box-shadow: 1px 2px 8px -2px rgba(0, 0, 0, 0.2)
      }
    }

  }
</style>


// WEBPACK FOOTER //
// src/components/parts/menu-lateral.vue